import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation, Inject, AfterViewChecked, Injectable } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { NX_DATE_LOCALE, NxDateAdapter, NxDatepickerIntl } from '@aposin/ng-aquila/datefield';
import { CallmebackService } from '@core/services/callmeback.service';
import { CommonService } from '@core/services/common.service';
import { CallMeBack } from '@shared/models/call-me-back';
import moment, { Moment } from 'moment';
import holidays from '../../../../holidays.json';
import { Language } from '@shared/models/language';
import { Agent } from '@shared/models/agent';
import { AgentService } from '@core/services/agent.service';
import { LocaleService } from '@core/services/locale.service';
import { UserService } from '@core/services/user.service';
import { LoadingService } from '@core/services/loading.service';
import { PolicyService } from '@core/services/policy.service';
import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { DataService } from '@core/services/data.service';
import { ClaimService } from '@core/services/claim.service';
import { Policy } from '@shared/models/policy';
import { LOB } from '@shared/models/LOB';
import { Lob } from '@shared/models/lob-enum';
import { Claim } from '@shared/models/claim';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MyIntl extends NxDatepickerIntl {
    constructor(private translateService: TranslateService) {
        super();
        this.switchToMonthViewLabel = this.translateService.instant('common.date.month-view');
        this.switchToMultiYearViewLabel = this.translateService.instant('common.date.date-view');
    }
}

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {

    @ViewChild('template') templateRef: TemplateRef<any>;

    templateDialogRef: NxModalRef<any>;

    // form
    form: FormGroup;

    private startHour: number = 8;
    private startMinute: number = 0;
    private endHour: number = 18;

    private startHourWeekend: number = 9;
    private startMinuteWeekend: number = 0;
    private endHourWeekend: number = 17;

    private breakStart: string = '12';
    private breakStartMinute: string = '00';
    private breakEnd: string = '13';
    private breakEndMinute: string = '00';

    private granularity: number = 60;

    public hourData: Object = {};
    public hourDataArray: Array<string> = [];
    public formBEValid: boolean = false;

    public agents: Agent[];

    public topicDayRestriction = [
        3, 13, 774
    ];
    public LOB = new LOB();
    readonly lob: typeof Lob = Lob;

    private topicHoursChange = [
        {
            id: 3,
            startHour: 9,
            startHourWeekend: 9,
            endHour: 17,
            endHourWeekend: 17,
        },
        {
            id: 13,
            startHour: 9,
            startHourWeekend: 9,
            endHour: 17,
            endHourWeekend: 17,
        },
        {
            id: 774,
            startHour: 8,
            startHourWeekend: 9,
            endHour: 17,
            endHourWeekend: 17,
        }
    ];

    public topicData: Array<Object> = [
        {
            id: 774,
            name: 'contact-us.call-me-back.topic-claim'
        },
        {
            id: 127,
            name: 'contact-us.call-me-back.topic-insurance'
        },
        {
            id: 3,
            name: 'contact-us.call-me-back.topic-policy'
        },
        {
            id: 13,
            name: 'contact-us.call-me-back.topic-other'
        },
    ];


    public policies: {
        [policyNumber: string]: Policy;
    } = {};

    public claims: {
        [policyNumber: string]: {
            icon: string,
            claim: Claim;
        };
    } = {};

    constructor(
        private userService: UserService,
        private localeService: LocaleService,
        private commonService: CommonService,
        private callMeBackService: CallmebackService,
        private agentService: AgentService,
        private policyService: PolicyService,
        private claimService: ClaimService,
        private dataService: DataService,
        private translateService: TranslateService,
        public dialogService: NxDialogService,
        public dateAdapter: NxDateAdapter<Moment>,
        protected loadingService: LoadingService,
        @Inject(NX_DATE_LOCALE) private nxDateLocale: string,
        @Inject(NxDatepickerIntl) private intl: NxDatepickerIntl,
    ) {
        this.userService.getLoggedUser().subscribe(() => {
            this.localeService.activeLanguage.subscribe(language => {
                this.changeLocaleDatePicker(this.LanguageMapper(language));
            });
        });

        this.translateService.get('common.date.month-view').subscribe( x => {
            this.intl.switchToMonthViewLabel = x;
        })

        this.translateService.get('common.date.date-view').subscribe( x => {
            this.intl.switchToMultiYearViewLabel = x;
        })

        translateService.onLangChange.subscribe(x => {
            let lang = this.localeService.languages.find(y => y.code.toLowerCase() == x.lang);
            if (lang && lang.iso) {
                intl.switchToMonthViewLabel = translateService.instant('common.date.month-view');
                intl.switchToMultiYearViewLabel = translateService.instant('common.date.date-view');
                this.nxDateLocale = lang.iso;
            }
        });

    }

    ngOnInit(): void {
        if (this.commonService.callMeBackOPenModalsubscription === undefined) {
            this.commonService.callMeBackOPenModalsubscription = this.commonService.callMeBackOPenModalFunction.subscribe(
                () => { this.openModal(); });
        }

        this.form = new FormGroup({
            date: new FormControl({ value: '', disabled: true }, Validators.required),
            hour: new FormControl({ value: '', disabled: true }, Validators.required),
            topic: new FormControl('', Validators.required),
            policy: new FormControl(null),
            claim: new FormControl(null),
        });

        this.generateTimeSlots();

        this.policyService.getActivePolicies().subscribe(activePolicies => {
            activePolicies.forEach((activePolicy) => {
                this.policies[activePolicy.policyNumber] = activePolicy;
            });

            this.claimService.getClaimsActive().subscribe(activeClaims => {
                activeClaims.forEach((activeClaim) => {
                    if (this.policies[activeClaim.policyNumber]) {
                        this.claims[activeClaim.claimNumber] = {
                            icon: this.getGroupByLobId(this.policies[activeClaim.policyNumber].lineOfBusinessId).icon,
                            claim: activeClaim
                        };
                    }
                });
            });
        });

        this.agents = [];
        this.agentService.getAgents().subscribe(agents => {

            let tmpAgents = {};
            for (let i = 0; i < agents.list.length; i++) {

                if (agents.list[i].agentChannel !== 'INT' && agents.list[i].agentChannel !== 'CC' && agents.list[i].agentChannel !== 'UNK') {
                    if (tmpAgents[agents.list[i].agentId] == undefined) {
                        agents.list[i].cnt = 1;
                        agents.list[i].dateBeginNumber = new Date(agents.list[i].dateBegin).getTime();

                        /*if(agents[i].agentChannel == 'FO'){
                          agents[i].agentMobilAgn = '+421 2 50 122 222';
                          agents[i].agentEmailAgn = 'allianz@allianz.sk';
                        }*/
                        tmpAgents[agents.list[i].agentId] = agents.list[i];
                    } else {
                        tmpAgents[agents.list[i].agentId].cnt++;

                        let t = new Date(agents.list[i].dateBegin).getTime();
                        if (tmpAgents[agents.list[i].agentId].dateBeginNumber < t) {
                            tmpAgents[agents.list[i].agentId].dateBegin = t;
                        }
                    }
                }
            }

            this.agents = Object.values(tmpAgents);

            this.agents.sort(function (a, b) {
                if ((b.cnt - a.cnt) < 0) {
                    return -1;
                } else if ((b.cnt - a.cnt) > 0) {
                    return 1;
                } else {
                    return b.dateBeginNumber - a.dateBeginNumber;
                }
            });
        });
    }

    get offset(): string {
        return !this.form.get('topic').value || [13, 127].includes(Number(this.form.get('topic').value)) ? '0,0,0,5' : '0';
    }

    /**
    * return ActiveInsuranceGroup (used for icon)
    */
    getGroupByLobId(lobId: number): ActiveInsuranceGroup {
        return this.dataService.activeInsuranceGroups.find(group => group.lobIds.some(x => x === lobId));
    }

    topicBind() {
        this.form.get('policy').reset();
        this.form.get('claim').reset();
        if (this.form.get('topic').valid && this.form.get('topic').value != '') {
            this.form.controls['date'].enable();
        } else {
            this.form.controls['date'].disable();
        }
        this.generateTimeSlots();
    }

    policyBind(event: any) {
    }

    claimBind(event: any) {
    }

    timeBind() {
        if (this.form.get('date').valid && this.form.get('date').value != '') {
            this.form.controls.hour.enable();
        } else {
            this.form.controls.hour.disable();
        }
        this.generateTimeSlots();
    }

    private changeLocaleDatePicker(value) {
        this.dateAdapter.setLocale(value);
    }

    filterDate = (date: Moment): boolean => {


        let DatetimeAfterLastSlot = moment(moment(), 'HH:mm');

        // weekend
        if (date.day() == 0 || date.day() == 6) {
            return false;
//             let end = this.endHourWeekend;
//             this.topicHoursChange.forEach(element => {
//                 if (element.id == this.form.value.topic) {
//                     end = element.endHourWeekend;
//                 }
//             });
// 
//             DatetimeAfterLastSlot.set({
//                 'hour': end + 1, // endHourWeekend + 1
//                 'minute': 0
//             });
// 
//             for (let i = 0; i < this.topicDayRestriction.length; i++) {
//                 if (this.topicDayRestriction[i] == this.form.get('topic').value) {
//                     return false;
//                 }
//             };

        } else {

            let end = this.endHour;
            this.topicHoursChange.forEach(element => {
                if (element.id == this.form.value.topic) {
                    end = element.endHour;
                }
            });

            DatetimeAfterLastSlot.set({
                'hour': end + 1, // endHour + 1
                'minute': 0
            });
        }

        if (!date.isAfter(moment(), 'day')) {
            return false;
        }

        // today date time after last time slot
        /*if (DatetimeAfterLastSlot.isBefore(moment(), 'minute')) {
          return false;
        }*/

        // history
        if (date.isBefore(moment(), 'day')) {
            return false;
        }

        // future bound
        if (date.isAfter(moment.now() + (90 * (1000 * 60 * 60 * 24)))) {
            return false;
        }

        // holidays
        for (const [dateHoliday, nameHoliday] of Object.entries(holidays)) {
            if (moment(moment(date.format('YYYY-MM-DD'))).isSame(moment(dateHoliday), 'day')) {
                return false;
            }
        }

        return true;
    };

    generateTimeSlots() {

        if (this.form.get('date').value == "" || this.form.get('date').invalid) {
            this.hourDataArray = [];
        } else {

            let formDate = this.form.get('date').value;
            // weekend
            if (formDate.day() == 0 || formDate.day() == 6) {
                this.hourData = {};
                let startMinute = this.startMinuteWeekend;

                let start = this.startHourWeekend - 1;
                let end = this.endHourWeekend;
                this.topicHoursChange.forEach(element => {
                    if (element.id == this.form.value.topic) {
                        start = element.startHourWeekend - 1;
                        end = element.endHourWeekend;
                    }
                });

                for (var i = start; i <= end; startMinute += this.granularity) {
                    let minute = '30';
                    if (startMinute % 60 == 0) {
                        minute = '00';
                        i++;
                        if (i == end) {
                            break;
                        }
                    }

                    let time = moment(moment(), 'HH:mm');
                    time.set({
                        'hour': i,
                        'minute': Number(minute)
                    });

                    // today history remove
                    if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                        continue;
                    }

                    // lunch
                    if (Number(i.toString() + minute) >= Number(this.breakStart + this.breakStartMinute) && Number(i.toString() + minute) <= Number(this.breakEnd + this.breakEndMinute)) {
                        continue;
                    }

                    this.hourData[i.toString() + ":" + minute] = i.toString() + ":" + minute;
                }

                this.hourDataArray = Object.keys(this.hourData);

            }
            else // weekday
            {
                this.hourData = {};
                let startMinute = this.startMinute;

                let start = this.startHour - 1;
                let end = this.endHour;
                this.topicHoursChange.forEach(element => {
                    if (element.id == this.form.value.topic) {
                        start = element.startHour - 1;
                        end = element.endHour;
                    }
                });

                for (var i = start; i <= end; startMinute += this.granularity) {
                    let minute = '30';
                    if (startMinute % 60 == 0) {
                        minute = '00';
                        i++;
                        if (i == end) {
                            break;
                        }
                    }

                    let time = moment(moment(), 'HH:mm');
                    time.set({
                        'hour': i,
                        'minute': Number(minute)
                    });

                    // today history remove
                    if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                        continue;
                    }

                    // lunch
                    if (Number(i.toString() + minute) >= Number(this.breakStart + this.breakStartMinute) && Number(i.toString() + minute) <= Number(this.breakEnd + this.breakEndMinute)) {
                        continue;
                    }

                    this.hourData[i.toString() + ":" + minute] = i.toString() + ":" + minute;
                }

                this.hourDataArray = Object.keys(this.hourData);
            }
        }
    }


    submit(event: Event) {
        event.preventDefault();

        let date = '';

        // date not valid
        if (this.form.value.date == "" || !this.form.value.date.isValid()) {
            this.form.get('date').setErrors({ valid: false });
        }
        // date is history
        else if (moment(this.form.value.date.format('MM-DD-YYYY')).isBefore(moment().format('MM-DD-YYYY'), 'day')) {
            this.form.get('date').setErrors({ history: true });
        }  // future bound
        else if (moment(this.form.value.date.format('MM-DD-YYYY')).isAfter(moment.now() + (90 * (1000 * 60 * 60 * 24)))) {
            this.form.get('date').setErrors({ future: true });
        }
        else {

            // holidays
            for (const [dateHoliday, nameHoliday] of Object.entries(holidays)) {
                if (moment(moment(this.form.value.date.format('YYYY-MM-DD'))).isSame(moment(dateHoliday), 'day')) {
                    this.form.get('date').setErrors({ holiday: true });
                }
            }

            // valid
            let d = this.form.value.date.date();
            let m = this.form.value.date.month() + 1;
            let y = this.form.value.date.year();

            date = y.toString() + '-' + m.toString() + '-' + d.toString();
        }

        let hour = this.form.value.hour;
        if (this.hourData[hour] == undefined) { // not in available time
            this.form.get('hour').setErrors({ valid: false });
        } else {

            let tmpHour = hour.split(':');
            // time has gone
            let time = moment(moment(), 'HH:mm');
            time.set({
                'hour': tmpHour[0],
                'minute': Number(tmpHour[1])
            });

            if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                this.form.get('hour').setErrors({ history: true });
            }

        }

        let topic = this.form.value.topic;
        [3].includes(Number(topic)) && this.form.value.policy == null && Object.keys(this.policies).length !== 0 ? this.form.get('policy').setErrors({ policy: 'error' }) : null;
        [774].includes(Number(topic)) && this.form.value.claim == null && Object.keys(this.claims).length !== 0 ? this.form.get('claim').setErrors({ claim: 'error' }) : null;

        if (!isNaN(topic) && this.form.valid) {

            let callMeBack = new CallMeBack();
            callMeBack.date = date;
            callMeBack.hour = hour;
            callMeBack.topic = topic;
            callMeBack.policy = this.form.value.policy;
            callMeBack.claim = this.form.value.claim;

            this.callMeBackService.postCallMeBack(callMeBack).subscribe(res => {
                if (res && res.errors && Object.entries(res.errors).length > 0) {
                    for (const [key, value] of Object.entries(res.errors)) {
                        let err = {};
                        err[value] = true;
                        this.form.get(key).setErrors(err);
                    }
                } else {
                    this.formBEValid = true;
                }
            });
        }

    }

    openModal(): void {
        this.templateDialogRef = this.dialogService.open(this.templateRef, { showCloseIcon: true });
    }

    private LanguageMapper(language: Language) {
        if (language.code == 'SK') {
            return 'sk-SK';
        }

        return 'en-US';
    }

    newRequest() {
        this.form.reset();
        this.formBEValid = false;
    }
}
